import React from "react";
import Layout from "../components/theme/layout";
import VideoSection from "../components/util/video-section";
import { Seo } from "../components/theme/seo";

const video_urls = [
  "https://youtube.com/embed/3l9QCOXisRY",
  "https://youtube.com/embed/K3BpNYn7-fY",
  "https://youtube.com/embed/Q3ssNNRI0wA",
  "https://youtube.com/embed/zd5fO9ceZFw",
];

export default function VideoPage({ location }) {
  return (
    <Layout location={location}>
      {video_urls.map((url, index) => (
        <VideoSection key={index} video_url={url} />
      ))}
    </Layout>
  );
}

export const Head = ({ data, location }) => (
  <Seo
    title={`Video`}
    description={`Video Archives for Next Response Foundation`}
    pathname={`${location.pathname}`}
  />
);